export { DMS_MODULE } from '../constants';
export const NAME = 'ItemsReceivedDetail(GRN)';
export const API_NAME = 'ItemsReceivedDetail';
export const CRUMB_LABEL_KEY = 'ItemsReceivedDetail(GRN)';
export const addOneMonth = 1;
export const subtractOneDay = 1;

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
